import { SessionProvider } from './app/session';
import { ToastProvider } from './components';
import { AppRoutes } from './routes/AppRoutes';

/** Application root: session → toasts → routes (all derived from routes/manifest.ts). */
export function App() {
  return (
    <SessionProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </SessionProvider>
  );
}
